const Header = () => {
  return <header className="w-full min-h-16 bg-red-600"></header>;
};

export default Header;
